import React from "react";

import { ReactComponent as HandshakeIcon } from "../../assets/handshake-emoji.svg";
import { ReactComponent as Quantiphi } from "../../assets/quantiphi.svg";
import { ReactComponent as Peoplegrove } from "../../assets/peoplegrove.svg";

import "./Companies.scss";

const Companies = () => {
  return (
    <div className="companies">
      <p>
        Companies I've Worked Alongside{" "}
        <HandshakeIcon className="svg-title-icon" />{" "}
      </p>
      <div className="companies-logo">
        <Quantiphi />
        <Peoplegrove />
      </div>
    </div>
  );
};

export default Companies;
